export default __webpack_public_path__ + "static/media/light_them_up_icon.4e3fc0f7.png";